import { ButtonProps } from '@slal/ui/buttons';
import { StyledButton } from './styles';

export const CardButton = (props: ButtonProps) => <StyledButton {...props} />;
